/* eslint-disable flowtype/require-return-type */
/* @flow strict */

import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Auth from './modules/Auth';
import AuthPage from './pages/Auth';
import { SettingsPageAccount, SettingsPageReferrals } from './pages/Settings';
import Sponsors from './pages/Sponsors';
import FeeCalc from './pages/FeeCalc';
import { EventRoutes } from './pages/Events/routes';
import { PayoutsRoutes } from './pages/Payouts/routes';
import { PaymentRoutes } from './pages/Payment/routes';
import { DBRoutes } from './pages/DB/routes';
import { IntegrationsRoutes } from './pages/Integrations/routes';
import { CheckInRoutes } from './pages/CheckIn/routes';


export type RouteType = {
  Component: React.ComponentType<{}>,
  params: {
    exact?: boolean,
    path: string
  }
};

export type RoutesType = Array<RouteType>;

const PrivateRoute = ({ component: Component, ...rest }: { component: any }): any => {
  return (
    <Route {...rest} render={(props: { location: any }): any => (
      Auth.isUserAuthenticated() ? (
        <Component {...rest} {...props} />
      ) : (
        <Redirect to={{
            pathname: '/login',
            state: { from: props.location }
          }}
        />
      )
    )}
    />
  );
};

const LoggedOutRoute = ({ component: Component, ...rest }: { component: any }): any => {
  return (
    <Route {...rest} render={(props: { location: any }) => (
      Auth.isUserAuthenticated() ? (
        <Redirect to={{
          pathname: '/events',
          state: { from: props.location }
        }}
        />
      ) : (
        <Component {...rest} {...props} />
      )
    )}
    />
  );
};

const routes: RoutesType = [
  ...PayoutsRoutes,
  ...DBRoutes,
  ...PaymentRoutes,
  ...IntegrationsRoutes,
  ...CheckInRoutes,
  { Component: Sponsors, params: { path: '/sponsors' } },
  { Component: SettingsPageAccount, params: { path: '/settings/account' } },
  { Component: SettingsPageReferrals, params: { path: '/settings/referrals' } },
  { Component: FeeCalc, params: { path: '/feeCalc' } },
  ...EventRoutes
];

const authRoutes: RoutesType = [
  { Component: AuthPage, params: { path: '/confirm-email' } },
  { Component: AuthPage, params: { path: '/resend-email' } },
  { Component: AuthPage, params: { path: '/reset-password' } },
  { Component: AuthPage, params: { path: '/login' } },
  { Component: AuthPage, params: { path: '/account/active' } }

];

const privatRoutes = (): [] => _.map(routes, ({ Component, params }: {}, rai: number): React.Node => {
  return (
    <PrivateRoute
      key={`Route-number-${rai}`}
      path={params.path}
      component={Component}
    />
  );
});

const loggedOutRoutes = (toggleAuthenticateStatus: () => void): [] => _.map(authRoutes, ({
 Component,
 params
}: {}, rai: number): React.Node => {
  return (
    <LoggedOutRoute
      key={`Route-number-${rai}`}
      path={params.path}
      component={Component}
      toggleAuthenticateStatus={(): void => toggleAuthenticateStatus()}
    />
  );
});

export default { loggedOutRoutes, privatRoutes };
